import Flickity from 'flickity'
import applyStyle from '../util/applyStyle.js'

export default function flickity ($el, options) {
  if (options.options) {
    options = options.options
  }

  let flkty = new Flickity($el, options)
  let dragOffset = { x: 0, y: 0 }
  let mouseOffset = { x: 0, y: 0 }
  let circlePosition = { x: 0, y: 0 }

  let circle = document.createElement('div')
  circle.className = 'drag-indicator'
  applyStyle(circle, {
    width: '80px',
    height: '80px',
    border: '2px solid rgba(255, 255, 255, 0.2)',
    position: 'absolute',
    top: 0,
    left: 0,
    borderRadius: '999px',
    marginLeft: '-40px',
    marginTop: '-40px',
    pointerEvents: 'none',
    opacity: 0,
    transform: 'scale(0.8)',
    transition: 'opacity 0.25s, transform 0.25s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10
  })
  circle.innerHTML = `
    <svg width="40" height="14" viewBox="0 0 40 14">
      <g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="2" transform="translate(1.657 1)">
        <polyline points="10 2 10 10 2 10" transform="rotate(135 6 6)"/>
        <polyline points="35 2 35 10 27 10" transform="rotate(-45 31 6)"/>
      </g>
    </svg>
  `

  $el.appendChild(circle)

  function onMouseEnter () {
    if (!flkty.isDraggable || window.True.isTouch) return
    circle.style.opacity = 1
    circle.style.transform = 'none'
  }

  function onMouseLeave () {
    circle.style.opacity = 0
    circle.style.transform = 'scale(0.8)'
  }

  function onMouseMove (e) {
    let rect = $el.getBoundingClientRect()
    let bodyRect = document.body.getBoundingClientRect()
    let elementOffsetX = rect.left - bodyRect.left
    let elementOffsetY = rect.top - bodyRect.top
    mouseOffset = {
      x: e.clientX + window.pageXOffset - elementOffsetX,
      y: e.clientY + window.pageYOffset - elementOffsetY
    }
  }

  $el.addEventListener('mouseenter', onMouseEnter)
  $el.addEventListener('mouseleave', onMouseLeave)
  $el.addEventListener('mousemove', onMouseMove)

  let raf
  function updateCircle () {
    let newX = mouseOffset.x + dragOffset.x
    let newY = mouseOffset.y + dragOffset.y

    circlePosition.x = circlePosition.x + (newX - circlePosition.x) / 3
    circlePosition.y = circlePosition.y + (newY - circlePosition.y) / 3

    circle.style.left = `${circlePosition.x}px`
    circle.style.top = `${circlePosition.y}px`
    raf = window.requestAnimationFrame(updateCircle)
  }
  raf = window.requestAnimationFrame(updateCircle)

  flkty.on('dragEnd', () => {
    dragOffset = { x: 0, y: 0 }
  })

  flkty.on('dragMove', (e, pointer, vector) => {
    dragOffset = vector
  })

  // https://github.com/metafizzy/flickity/issues/740
  // https://github.com/metafizzy/flickity/issues/740#issuecomment-485562201
  let startX = 0
  function onTouchStart (e) {
    startX = e.touches[0].clientX
  }
  function onTouchMove (e) {
    if (
      Math.abs(e.touches[0].clientX - startX) > flkty.options.dragThreshold &&
      e.cancelable
    ) {
      e.preventDefault()
    }
  }

  $el.addEventListener('touchstart', onTouchStart)
  $el.addEventListener('touchmove', onTouchMove)

  return () => {
    $el.removeEventListener('mouseenter', onMouseEnter)
    $el.removeEventListener('mouseleave', onMouseLeave)
    $el.removeEventListener('mousemove', onMouseMove)
    $el.removeEventListener('touchstart', onTouchStart)
    $el.removeEventListener('touchmove', onTouchMove)
    window.cancelAnimationFrame(raf)
    circle.parentNode.removeChild(circle)
    flkty.destroy()
  }
}



// WEBPACK FOOTER //
// ./src/js/components/flickity.js